import React from "react";
import { Button, Wrap, WrapItem } from "@chakra-ui/react";

export const BoardButton = ({ label, onClick }) => {
  return (
    <Button
      onClick={onClick}
      variant="ghost"
      px="14px"
      py="8px"
      borderRadius="28px"
      border="1px solid #E4E4E4"
      bg="#FFF"
      _hover={{ bg: "#E4E4E4" }}
      _active={{ bg: "#E4E4E4" }}
      color="#343634"
      fontSize="14px"
      fontWeight="400"
      lineHeight="normal"
      h="auto"
    >
      {label}
    </Button>
  );
};

const BoardsButtons = ({ items = [], onSelect }) => {
  return (
    <Wrap spacing="8px">
      {items.map((item) => (
        <WrapItem key={item}>
          <BoardButton label={item} onClick={() => onSelect?.(item)} />
        </WrapItem>
      ))}
    </Wrap>
  );
};

export default BoardsButtons;
